import { fbaConversionFactors } from "../components/fba/fbaConversionFactors";
import { E3M3_TO_MCF, M3_TO_BBL } from "./conversionFactors";

export async function parseFbaCsv(file, units) {
  try {
    if (!file) return false;
    
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      
      reader.readAsText(file);
  
      let fbaProductionData = [];
      
      reader.onload = (event) => {
        let result = event.target.result;
  
        if (result.length > 0) {
          let data = result.split('\r\n');
          const headers = data?.splice(0,1)?.[0]?.split(','); // get csv headers
  
          let colIndices = {
            date: undefined,
            days: undefined,
            pwh: undefined,
            pwf: undefined,
            oil: undefined,
            gas: undefined,
            water: undefined,
            condensate: undefined,
            salinity: undefined
          };
      
          headers.forEach((col,i) => { // find indices of columns in the headers
            if (col.match(/date/ig)) colIndices.date = i;
            if (col.match(/days/ig)) colIndices.days = i;
            if (col.match(/pwh/ig) || col.match(/p_wh/ig) || col.match(/pressure/ig)) colIndices.pwh = i;
            if (col.match(/pwf/ig) || col.match(/p_wf/ig)) colIndices.pwf = i;
            if (col.match(/oil/ig)) colIndices.oil = i;
            if (col.match(/gas/ig)) colIndices.gas = i;
            if (col.match(/water/ig)) colIndices.water = i;
            if (col.match(/condensate/ig)) colIndices.condensate = i;
            if (col.match(/salinity/ig)) colIndices.salinity = i;
          });
  
  
          data.forEach(d => {
  
            if (d.replaceAll(/,/g,'')?.length > 0) {
  
              const row = d?.split(',');
              
              fbaProductionData.push({
                date: (row[colIndices.date] ? new Date(row[colIndices.date]) : null),
                days: (Number(row[colIndices.days]) || null),
                pwh: (units === 'field' ? Number(row[colIndices.pwh]) : Number(row[colIndices.pwh]) / fbaConversionFactors.pwh) || 0,
                pwf: (units === 'field' ? Number(row[colIndices.pwf] || row[colIndices.pwh]) : Number(row[colIndices.pwf] || row[colIndices.pwh]) / fbaConversionFactors.pwf) || 0,
                oil: (Number(row[colIndices.oil]) > 0 ? (units === 'field' ? Number(row[colIndices.oil]) : (Number(row[colIndices.oil]) * M3_TO_BBL)) : 0.0001),
                gas: (Number(row[colIndices.gas]) > 0 ? (units === 'field' ? Number(row[colIndices.gas]) : (Number(row[colIndices.gas]) * E3M3_TO_MCF)) : 0.0001),
                water: (Number(row[colIndices.water]) > 0 ? (units === 'field' ? Number(row[colIndices.water]) : (Number(row[colIndices.water]) * M3_TO_BBL)) : 0.0001),
                condensate: (Number(row[colIndices.condensate]) > 0 ? (units === 'field' ? Number(row[colIndices.condensate]) : (Number(row[colIndices.condensate]) * M3_TO_BBL)) : 0.0001),
                salinity: (Number(row[colIndices.salinity]) || 0)
              });
  
            };
          });
          
          const startDate = fbaProductionData?.[0]?.date ? new Date(fbaProductionData?.[0]?.date) : new Date();
  
          fbaProductionData.forEach((d,i) => {
            const currentDate = new Date(fbaProductionData[i+1]?.date ? fbaProductionData[i+1]?.date : d.date);
            let days = (currentDate - startDate) / (1000*60*60*24); // convert ms to days
            if (i === fbaProductionData?.length - 1) {
              days += fbaProductionData[i-1]?.days - fbaProductionData[i-2]?.days;
            };
            
            const delta = i === 0 ? days : (days - fbaProductionData[i-1].days); // calculate delta in days
            
            fbaProductionData[i].days = days;
            
            fbaProductionData[i].sqrtDays = Math.sqrt(fbaProductionData[i].days); // calculate sqrt(t)
            fbaProductionData[i].gor = (d.oil > 0.0001 && d.gas > 0.0001) ? ((1000 * d.gas) / d.oil) : 0; // calculate gor
            fbaProductionData[i].owr = (d.water > 0.0001 && d.oil > 0.0001) ? (d.oil / d.water) : 0; // calculate owr
            fbaProductionData[i].gwr = (d.water > 0.0001 && d.gas > 0.0001) ? (d.gas / d.water) : 0; // calculate gwr
            fbaProductionData[i].cgr = (d.condensate > 0.0001 && d.gas > 0.0001) ? (d.condensate / (d.gas / 1000)) : 0; // calculate cgr
            fbaProductionData[i].cumWater = (d.water > 0 ? d.water * (delta) : 0.00001) + (i > 0 ? fbaProductionData?.[i-1]?.cumWater : 0) // calculate cum water
            fbaProductionData[i].cumOil = (d.oil > 0 ? d.oil * (delta) : 0.00001) + (i > 0 ? fbaProductionData?.[i-1]?.cumOil : 0) // calculate cum oil
            fbaProductionData[i].cumGas = (d.gas > 0 ? d.gas * (delta) : 0.00001) + (i > 0 ? fbaProductionData?.[i-1]?.cumGas : 0) // calculate cum gas
            fbaProductionData[i].cumCondensate = (d.condensate > 0 ? d.condensate * (delta) : 0.00001) + (i > 0 ? fbaProductionData?.[i-1]?.cumCondensate : 0); // calculate cum condensate
          });

          resolve({rawData: fbaProductionData, fileName: file?.name, fileSize: file?.size / 1000});
        };
      };

      reader.onerror = () => {
        reject({rawData: null, fileName: null, fileSize: null});
      };
    });

  } catch (error) {
    console.log(error);
    return {rawData: null, fileName: null, fileSize: null};
  };
};
